import { useLocation, Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth.js';

const ERROR_MESSAGES = {
  not_member: "You're not a member of the UnearthWorx Discord server. Ask an admin for an invite, then try signing in again.",
  missing_role: "Your Discord account is in the server but you don't have the role required to access payroll. Ask an admin to grant you the right role.",
  server_config: 'Sign-in failed because the server isn\'t configured correctly. Contact an admin.',
};

export default function LoginPage() {
  const { isAuthed, isLoading } = useAuth();
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  if (isLoading) return <div className="loading">Loading…</div>;

  // Already signed in — go straight to wherever they were headed.
  if (isAuthed) {
    const returnTo = params.get('return_to') || '/clock';
    return <Navigate to={returnTo} replace />;
  }

  const returnTo = params.get('return_to') || '/clock';
  const startUrl = `/api/auth/discord/start?return_to=${encodeURIComponent(returnTo)}`;
  const errorCode = params.get('error');
  const errorMessage = errorCode ? (ERROR_MESSAGES[errorCode] || 'Sign-in failed. Please try again.') : null;

  return (
    <main className="login-screen">
      <div className="login-card ptex">
        <div className="login-logo">UNEARTH<span>WORX</span></div>
        <div className="login-subtitle">Crew payroll &amp; time tracking</div>
        {errorMessage && (
          <div className="banner error" style={{ marginBottom: 20, textAlign: 'left' }}>
            {errorMessage}
          </div>
        )}
        <a className="btn-primary login-btn" href={startUrl}>
          <i className="ph ph-discord-logo" />
          Sign in with Discord
        </a>
        <div className="login-hint">You must be a member of the UnearthWorx server.</div>
      </div>
    </main>
  );
}
